import TemplateContent, {
  TemplateGroup,
} from '@ax2/common/model/schemas/TemplateContent';
import {
  isTemplateEditable,
  templateRegExp,
  getGroupKey,
} from '@ax2/common/helpers/template';
import {
  TemplateElementData,
  TemplateContentElementData,
} from 'components/question-builders/base/TemplateContentElement';
import _ from 'lodash';

export const getTemplateData = (
  content: TemplateContent,
  onChange?: (content: TemplateContent) => void
): TemplateContentElementData => {
  const texts = _.split(content.template, templateRegExp());
  const tKeys = content.template.match(templateRegExp());
  const data: TemplateElementData[] = [];
  if (texts.length > 1 && tKeys && tKeys.length > 0) {
    _.forEach(texts, (text, index) => {
      if (text.length > 0) {
        data.push({ value: text });
      }
      if (index === 0 || index !== texts.length - 1) {
        const gKey = getGroupKey(tKeys[index]);
        if (gKey !== null && content.groups) {
          const group = content.groups[gKey];
          data.push({
            value: group.text,
            rteValue: group.rteText,
            placeholder: group.placeholder,
            onChange: (t, rt) => {
              onChange &&
                onChange(getUpdatedContext(content, gKey, group, t, rt));
            },
          });
        }
      }
    });
  } else if (texts.length === 1) {
    data.push({ value: texts[0] });
  }
  return {
    templateType: isTemplateEditable(content) ? 'template' : 'text',
    templateData: data,
  };
};

const getUpdatedContext = (
  content: TemplateContent,
  gKey: number,
  group: TemplateGroup,
  text: string | null,
  rteText: string | null | undefined
): TemplateContent => {
  const nGroup: TemplateGroup = { ...group, text: text, rteText: rteText };
  const nGroups: { [index: number]: TemplateGroup } = {
    ...content.groups,
  };
  nGroups[gKey] = nGroup;
  return {
    ...content,
    groups: nGroups,
  };
};
